export default ({ Factory }) => ({
  /**
   * Создание канала
   * @param {Object} channel Канал
   */
  create: (channel) => Factory.post(channel),

  /**
   * Обновление канала
   * @param {Object} channel Канал
   */
  update: (channel) => Factory.put(channel),

  /**
   * Удаление канала
   * @param {String} id - идентификатор канала
   */
  remove: (id) => Factory.delete(id),

  /**
   * Список каналов
   */
  list: () => Factory.list.get(),

  /**
   * Типы каналов
   */
  types: () => Factory.types.get(),

  /**
   * Список основных каналов
   */
  main: () => Factory.main.get(),
  
  /**
   * Получение канала
   * @param {String} id - идентификатор канала
   */
  get: (id) => Factory[id].get(),
  
  /**
   * Получение канала
   * @param {String} name - псевдоимя канала
   */
  alias: (name) => Factory.alias[name].get(),
})
